import React, { useEffect, useState } from 'react';
import { UtilityService } from '../../../services/UtilityService';



interface Props  {
    MediaUrl: string;
    controls: boolean;
    mediaDisplay?: () => void;
}

const Video = (props: Props) => {

    const [url, setUrl] = useState<string>()
    useEffect(() => {
        UtilityService.convertUrlToBlob(props.MediaUrl).then(res => {
            setUrl(res)
        });
    }, [])

    const handleOnClick = (event: React.MouseEvent<HTMLVideoElement, MouseEvent>) => {
        event.preventDefault();
        props.mediaDisplay?.call(props);
    }
    const { controls} = props
    return (
        <video controls={controls} controlsList="nodownload" src={url} onClick={handleOnClick} className={`display-video ${!controls ? "textMedia"  : "media"}`} />
    )
}
export default Video